/**
 * Log error to atatus
 * 
 * @param {Object} error
 * 
 * @returns {void}
 */
export async function logErrorToAtatus(message, error) {
    if(message && error && window.atatus && error?.response?.status !== 422) {
        const _err = new Error(message)
        const messageStack =  {
            message: message,
            error: error?.message,
        }
        window.atatus.notify(_err, messageStack)

        console.error(message, {...messageStack, stack: error?.stack})
    }
}